import React, {Component} from 'react';

import {
    ButtonGroup
} from 'reactstrap';

class RadioButtons extends Component {
    state = {
        active: this.props.children.length > 0 ? this.props.children[0].props.value : null
    };

    render() {
        let color = this.props.color;
        let outline = this.props.outline;

        const keyedChildren = React.Children.map(this.props.children, (child, i) => {
            return React.cloneElement(child, {
                key: i,
                color: color,
                outline: outline,
                active: this.state.active === child.props.value,
                onClick: () => {
                    this.setState({active: child.props.value});
                    this.props.onStateChange && (this.props.onStateChange(child.props.value));
                }
            });
        });

        return (
            <div>
                <ButtonGroup>
                    {keyedChildren}
                </ButtonGroup>
            </div>
        );
    }
}

export default RadioButtons;


// WEBPACK FOOTER //
// ./src/components/controls/buttons/RadioButtons.js